import React, { useState }  from 'react'
import { Row, Col, Button } from 'react-bootstrap'
import ViewButton from './view-button'
import AbsolutePosition from '../../common/absolute-position'
import IconLabel from '../../common/icon-label'
import { PeopleFill, Calendar3 } from 'react-bootstrap-icons'
import Date from '../../date/numerical'


const SurveyListItem = ({
    item,
}) => {
    return (
        <Col xl={12} style={{ paddingTop: '20px'}}>
            <div
                className='noselect'
                style={{
                    boxShadow: '0px 0px 20px 10px rgb(238, 247, 255)',
                }}
            >
                <div style={{ padding: '20px', flexGrow: '0.8'}}>
                    <AbsolutePosition top='30px' right='30px'>
                        <ViewButton itemId={item.id} />
                    </AbsolutePosition>
                    <div><h2>{item.name}</h2></div>
                    <div className='three-line-ellipsis' style={{ paddingTop: '10px', color: 'black'}}>{item.description}</div>
                </div>
            </div>
        </Col>
    )
}

export default SurveyListItem
